import React from 'react';
import { SubscriptionLayout } from '../components/SubscriptionLayout';
import { Payments } from '../components/Payments';

export const PaymentsPage = () => {
  return (
    <SubscriptionLayout activeTab="payments">
      <Payments />
    </SubscriptionLayout>
  );
};
